import axios from 'axios';
import {errors as E} from 'common/constants/errors';

export const GET_LIST = 'steps/getStep9TabTaxAuthority';

export const getList = async (request) => {
  try {
    const response = await axios.post(GET_LIST, request);

    const {body, errorCode} = response.data;

    if (errorCode < 0) {
      throw new Error(E.SERVER_ERROR);
    }

    const {
      gridData: list,
      totalPageCount,
      currentPageNumber,
      totalResultCount,
    } = body;

    return {
      list,
      totalPageCount,
      currentPageNumber,
      totalResultCount,
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
};